<template>
  <div class="not-found-component">
    <div class="not-found-component__error">
      404
    </div>
    <div class="not-found-component__text">
      Not Found
    </div>
  </div>
</template>
<script>
export default {
  name: "NotFoundComponent",
}
</script>
